/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Numberoffellowmentees3Inputs */

const en__field_numberoffellowmentees3 = /** @type {(inputs: _Field_Numberoffellowmentees3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Size`)
};

const de__field_numberoffellowmentees3 = /** @type {(inputs: _Field_Numberoffellowmentees3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schüler:innen Guppengröße`)
};

/**
* | output |
* | --- |
* | "Group Size" |
*
* @param {_Field_Numberoffellowmentees3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_numberoffellowmentees3 = /** @type {((inputs?: _Field_Numberoffellowmentees3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Numberoffellowmentees3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_numberoffellowmentees3(inputs)
	return de__field_numberoffellowmentees3(inputs)
});
export { _field_numberoffellowmentees3 as "_field_numberOfFellowMentees" }